export default __webpack_public_path__ + "static/learning-77a6c4450386ee0367e485f531ab9bdc.png";